import { cx } from "shared/utils";

export const LeastMostLabel = ({
  most,
  className
}: {
  most?: boolean;
  className?: string;
}) => {
  const text = most ? "At most" : "At least";
  return (
    <div
      className={cx(
        "bg-alpha-40 rounded-md border border-alpha-40 py-2.5 px-3.5 flex items-center h-[48px]",
        className
      )}
    >
      <p className="text-sm text-content-200 font-medium">{text}</p>
    </div>
  );
};
